module.exports = __webpack_public_path__ + "static/media/bounce-logo.3921bc13.svg";